export default {
	title: "AI Meeting Summaries",
	uploadRecordingButton: "Upload recording",
	notNowButton: "Not now",
	doNotShowLabel: "Do not show this again.",
	bodyContent: [
		"<p>With AI Meeting Summaries, Teaming will create a meeting summary from a recording of your meeting and add it to your notes.</p>",
		"<p>Use AI Meeting Summaries to stay more engaged and connected to your team during meetings, with the peace of mind that notes are taken for you.</p>",
		"<p>Simply upload a video or audio recording of your meeting to get started. (Don’t worry, we don’t keep your recordings.)</p>",
	].join( "" ),
};
